





























































































import { Component, Vue } from "vue-property-decorator";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { MessageService } from "@/shared/services/message-service";
import { RouterNames } from "@/router/routernames";

@Component({})
export default class ClientsList extends Vue {
  public busqueda: string = "";
  public cargando: boolean = false;
  public soloDuplicados: boolean = false;
  public clients: any[] = [];

  public headers = [
    { text: "ID", value: "id", width: 60 },
    { text: "Nombre", value: "name" },
    { text: "Email", value: "email" },
    { text: "Teléfono", value: "phone" },
    { text: "Notas", value: "notes" },
    { text: "Fecha Registro", value: "datecreated" },
    { text: "Avisos", value: "avisos", sortable: false, width: 220 },
    { text: "Acciones", value: "acciones", sortable: false, align: "end", width: 80 }
  ];

  get clientesConAvisos() {
    const emailCount = new Map<string, number>();
    const phoneCount = new Map<string, number>();

    // Contar ocurrencias
    for (const c of this.clients) {
      if (c.email && c.email.trim() !== "") {
        const e = c.email.trim().toLowerCase();
        emailCount.set(e, (emailCount.get(e) || 0) + 1);
      }
      if (c.phone && c.phone.trim() !== "") {
        const p = c.phone.trim();
        phoneCount.set(p, (phoneCount.get(p) || 0) + 1);
      }
    }

    // Marcar duplicados
    return this.clients.map(c => {
      let isDuplicate = false;
      let reasons: string[] = [];
      
      if (c.email && c.email.trim() !== "") {
        const e = c.email.trim().toLowerCase();
        if ((emailCount.get(e) || 0) > 1) {
          isDuplicate = true;
          reasons.push("Email");
        }
      }
      if (c.phone && c.phone.trim() !== "") {
        const p = c.phone.trim();
        if ((phoneCount.get(p) || 0) > 1) {
          isDuplicate = true;
          reasons.push("Teléfono");
        }
      }
      
      return {
        ...c,
        isDuplicate,
        duplicateReasons: reasons.join(" y ")
      };
    });
  }

  get displayedClients() {
    if (this.soloDuplicados) {
      return this.clientesConAvisos.filter(c => c.isDuplicate);
    }
    return this.clientesConAvisos;
  }

  public async created() {
    await this.cargarClientes();
  }

  public async cargarClientes() {
    this.cargando = true;
    try {
      const response = await ssmHttpService.get(API.clients, undefined, false);
      this.clients = response || [];
    } catch (error) {
      MessageService.toast("Error al cargar los clientes", MessageService.TypeWarning);
      console.error("Error fetching clients", error);
    } finally {
      this.cargando = false;
    }
  }

  public formatFecha(fechaIso: string): string {
    if (!fechaIso) return "-";
    const date = new Date(fechaIso);
    return date.toLocaleDateString("es-ES", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  }

  public verFicha(item: any) {
    this.$router.push({
      name: RouterNames.crm_ficha,
      params: { id: item.id.toString() },
    });
  }

  public nuevoCliente() {
    this.$router.push({
      name: RouterNames.crm_ficha,
      params: { id: "-1" },
    });
  }
}
